import { Eye, EyeOff } from 'lucide-react'
import { cn } from '@/utils'
import {
  FIGMA_TEXT_FOREGROUND,
  FIGMA_TEXT_PRIMARY,
  PEZ_EYE_BUTTON_SIZE,
} from '@/components/app/photos/photo-effects/constants/photo-effect-row-layout'

export type PhotoEffectEyeButtonProps = {
  label: string
  active: boolean
  onToggle: () => void
  className?: string
}

/**
 * Shared eye toggle (Figma PEZ) — plain icon button, no border on any row kind.
 */
export function PhotoEffectEyeButton({
  label,
  active,
  onToggle,
  className,
}: PhotoEffectEyeButtonProps) {
  const Icon = active ? Eye : EyeOff
  const color = active ? FIGMA_TEXT_PRIMARY : FIGMA_TEXT_FOREGROUND

  return (
    <button
      type="button"
      aria-label={`Toggle ${label}`}
      aria-pressed={active}
      onClick={onToggle}
      className={cn(
        'flex items-center justify-center justify-self-start rounded-lg border-none bg-transparent p-0 hover:bg-black/[0.04]',
        className
      )}
      style={{ width: PEZ_EYE_BUTTON_SIZE, height: PEZ_EYE_BUTTON_SIZE, color }}
    >
      <Icon className="size-4" strokeWidth={1.33} aria-hidden="true" />
    </button>
  )
}
